
(function(algolia) {
  'use strict';
  algolia.translations = {
    core: {
		pages_result_title: {
			en: "Pages",
			fr: "Pages"
		},
		searchForProduct: {
			en: "Search for products",
			fr: "Recherche d'articles",
		},
		clearAll: {
			en: "Clear all",
			fr: "Tout effacer",
		},
		outOf: {
			en: "out of",
			fr: "de",
		},
		search_for: {
			en: "Search for",
			fr: "Rechercher pour",
		},
		no_match: {
			en: "No match for",
			fr: "Pas de correspondance pour",
		},
		noResult: {
			en: "No result for query",
			fr: "Aucun résultat pour votre demande",
		},
		width: {
			en: "Width",
			fr: "Largeur",
		},
		height: {
			en: "Height",
			fr: "Hauteur",
		},
		depth: {
			en: "Depth",
			fr: "Profondeur",
		},
		saved: {
			en: "Save",
			fr: "Économisez",
		},
		show: {
			en: "SHOW",
			fr: "Afficher",
		},
		hide: {
			en: "HIDE",
			fr: "Cacher",
		},
		showMore: {
			en: "Load more",
			fr: "Voir davantage"
		},
		showingStats_1: {
			en: "Showing",
			fr: "Voici les "
		},
		showingStats_2: {
			en: "results for",
			fr: "résultats trouvés pour "
		},
		showingStats_1_1: {
			en: "Showing 1 result for",
			fr: "Voici les 1 résultat pour "
		},
		show_previous: {
			en: "Show previous results",
			fr: "Afficher les résultats précédents"
		},
    },
    sortOptions: {
		relevance: {
			en: 'Relevance',
			fr: 'Pertinence',
		},
		"Popularity": {
			en: 'Popularity',
			fr: 'Popularité',
		},
		"Price_desc": {
			en: 'Price: High to low',
			fr: 'Prix : Ordre décroissant',
		},
		"Price_asc": {
			en: 'Price: Low to high',
			fr: 'Prix : Ordre croissant',
		},
    },
    facets: {
		// ALL CATEGORIES
		"price": {
			"en": "Price",
			"fr": "Prix",
		},
		"style": {
			"en": "Style",
			"fr": "Style",
		},
		"contemporary": {
			"en": "Contemporary",
			"fr": "Contemporain",
		},
		"modern": {
			"en": "Modern",
			"fr": "Moderne",
		},
		"retro": {
			"en": "Retro",
			"fr": "R\u00E9tro",
		},
		"traditional": {
			"en": "Traditional",
			"fr": "Traditionnel",
		},
		"rustic": {
			"en": "Rustic",
			"fr": "Rustique",
		},
		"industrial": {
			"en": "Industrial",
			"fr": "Industriel",
		},
		"glam": {
			"en": "Glam",
			"fr": "Somptueux",
		},
		"country": {
			"en": "Country",
			"fr": "Champ\u00EAtre",
		},
		"eclectic": {
			"en": "Eclectic",
			"fr": "\u00C9clectique",
		},

		"travel": {
			"en": "Travel",
			"fr": "Voyage",
		},
		"nature": {
			"en": "Nature",
			"fr": "Nature",
		},
		"architecture": {
			"en": "Architecture",
			"fr": "Architecture",
		},
		"ocean": {
			"en": "Ocean",
			"fr": "Oc\u00E9an",
		},
		"black and white": {
			"en": "Black and White",
			"fr": "Noir et blanc",
		},
		"animals": {
			"en": "Animals",
			"fr": "Animaux",
		},
		"mountains": {
			"en": "Mountains",
			"fr": "Montagnes",
		},
		"painting": {
			"en": "Painting",
			"fr": "Peintures",
		},
		"instrument": {
			"en": "Instrument",
			"fr": "Instrument",
		},
		"abstract": {
			"en": "Abstract",
			"fr": "Abstrait",
		},
		"sci-fi": {
			"en": "Sci-Fi",
			"fr": "Science-fiction",
		},
		"people": {
			"en": "People",
			"fr": "Gens",
		},
		"movies": {
			"en": "Movies",
			"fr": "Films",
		},
		"music": {
			"en": "Music",
			"fr": "Musique",
		},
		"superheroes": {
			"en": "Superheroes",
			"fr": "Super-h\u00E9ros",
		},

		"material": {
			"en": "Material",
			"fr": "Mat\u00E9riau",
		},
		"wood": {
			"en": "Wood",
			"fr": "Bois",
		},
		"fabric": {
			"en": "Fabric",
			"fr": "Tissu",
		},
		"stone": {
			"en": "Stone",
			"fr": "Pierre",
		},
		"leather": {
			"en": "Leather",
			"fr": "Cuir",
		},
		"metal": {
			"en": "Metal",
			"fr": "M\u00E9tal",
		},
		"glass": {
			"en": "Glass",
			"fr": "Verre",
		},
		"ceramic": {
			"en": "Ceramic",
			"fr": "C\u00E9ramique",
		},
		"plastic": {
			"en": "Plastic",
			"fr": "Plastique",
		},
		"concrete": {
			"en": "Concrete",
			"fr": "Béton"
		},
		"washable": {
			"en": "Washable",
			"fr": "Lavable"
		},

		"brand": {
			"en": "Brand",
			"fr": "Marque",
		},
		"designed2b": {
			"en": "Designed2B",
			"fr": "Design \u00E0 mon image",
		},
		"designed2b recliners": {
			"en": "Designed2B Recliners",
			"fr": "Fauteuils d'appoint inclinables Design \u00E0 mon image",
		},
		"ge": {
			"en": "GE",
			"fr": "GE",
		},
		"ge profile": {
			"en": "GE Profile",
			"fr": "GE Profile",
		},
		"ge café": {
			"en": "Cafe",
			"fr": "Caf\u00E9",
		},
		"lg": {
			"en": "LG",
			"fr": "LG",
		},
		"lg studio": {
			"en": "LG STUDIO",
			"fr": "LG STUDIO",
		},
		"kitchenaid": {
			"en": "KitchenAid",
			"fr": "KitchenAid",
		},
		"rca": {
			"en": "RCA",
			"fr": "RCA",
		},
		"ways to shop": {
			"en": "Ways to shop",
			"fr": "Fa\u00E7ons de magasiner",
		},
		"bmsm": {
			"en": "Buy more, Save more",
			"fr": "Achetez plus, Économisez plus",
		},
		"d2b": {
			"en": "Customizable",
			"fr": "Personnalisable",
		},
		"esr": {
			"en": "Ontario Rebate",
			"fr": "Rabais de l'Ontario",
		},
		"made in canada": {
			"en": "Made in Canada",
			"fr": "Fabriqu\u00E9 au Canada",
		},
		"made in italy": {
			"en": "Made in Italy",
			"fr": "Fabriqu\u00E9 en Italie",
		},
		"buyer's best": {
			"en": "Buyer's Best",
			"fr": "Articles Valeur s\u00FBre",
		},
		"buyers best": {
			"en": "Buyer's Best",
			"fr": "Articles Valeur s\u00FBre",
		},
		"brick outlet": {
			"en": "Brick Outlet",
			"fr": "Brick Boutique Entrep\u00F4t",
		},
		"exclusive": {
			"en": "Exclusive",
			"fr": "Exclusivit\u00E9 Brick",
		},
		"new": {
			"en": "New",
			"fr": "Nouveaut\u00E9s",
		},
		"energy star": {
			"en": "Energy Star",
			"fr": "ENERGY STAR",
		},
		"last chance": {
			"en": "Last Chance",
			"fr": "Derni\u00E8re Chance",
		},
		"marketplace": {
			"en": "Marketplace",
			"fr": "Place de marché"
		},
		"on sale": {
			"en": "On Sale",
			"fr": "\u00C9conomiser",
		},
		"hot buy": {
			"en": "Hot Buy",
			"fr": "Superbe achat",
		},
		"dropship": {
			"en": "Online Only",
			"fr": "En ligne seulement",
		},
		"online only": {
			"en": "Online Only",
			"fr": "En ligne seulement",
		},
		"multicolor": {
			"en": "More colours available",
			"fr": "Plus de couleurs offertes",
		},
		"postable": {
			"en": "Free shipping",
			"fr": "Livraison gratuite"
		},
		"btmButton": {
			"en": "Start Matching",
			"fr": "Completez le style"
		},
		"package size 2": {
			"en": "Package Size",
			"fr": "Format de l'ensemble",
		},
		"2-piece": {
			"en": "2-Piece",
			"fr": "2 pi\u00E8ces",
		},
		"3-piece": {
			"en": "3-Piece",
			"fr": "3 pi\u00E8ces",
		},
		"4-piece": {
			"en": "4-Piece",
			"fr": "4 pi\u00E8ces",
		},
		"5-piece": {
			"en": "5-Piece",
			"fr": "5 pi\u00E8ces",
		},
		"6-piece": {
			"en": "6-Piece",
			"fr": "6 pi\u00E8ces",
		},
		"7-piece": {
			"en": "7-Piece",
			"fr": "7 pi\u00E8ces",
		},
		"8-piece": {
			"en": "8-Piece",
			"fr": "8 pi\u00E8ces",
		},
		"9-piece": {
			"en": "9-Piece",
			"fr": "9 pi\u00E8ces",
		},
		"10-piece": {
			"en": "10-Piece",
			"fr": "10 pi\u00E8ces",
		},
		"colour or finish": {
			"en": "Colour or finish",
			"fr": "Couleur ou fini",
		},
		"dark brown": {
			"en": "Dark Brown",
			"fr": "Brun fonc\u00E9",
		},
		"grey": {
			"en": "Grey",
			"fr": "Gris",
		},
		"light brown": {
			"en": "Light Brown",
			"fr": "Brun clair",
		},
		"white": {
			"en": "White",
			"fr": "Blanc",
		},
		"black": {
			"en": "Black",
			"fr": "Noir",
		},
		"silver": {
			"en": "Silver",
			"fr": "Argent",
		},
		"beige": {
			"en": "Beige",
			"fr": "Beige",
		},
		"blue": {
			"en": "Blue",
			"fr": "Bleu",
		},
		"red": {
			"en": "Red",
			"fr": "Rouge",
		},
		"green": {
			"en": "Green",
			"fr": "Vert",
		},
		"orange": {
			"en": "Orange",
			"fr": "Orange",
		},
		"multi-colour": {
			"en": "Multi-Colour",
			"fr": "Multicolore",
		},
		"purple": {
			"en": "Purple",
			"fr": "Violet",
		},
		"yellow": {
			"en": "Yellow",
			"fr": "Jaune",
		},
		"neutral": {
			"en": "Neutral",
			"fr": "Neutre",
		},
		"pink": {
			"en": "Pink",
			"fr": "Rose",
		},
		"gold": {
			"en": "Gold",
			"fr": "Dor\u00E9",
		},
		"stainless steel": {
			"en": "Stainless Steel",
			"fr": "Acier inoxydable",
		},
		"black stainless steel": {
			"en": "Black Stainless Steel",
			"fr": "Acier inoxydable noir",
		},
		"custom": {
			"en": "Custom",
			"fr": "Personnalis\u00E9",
		},
		"copper": {
			"en": "Copper",
			"fr": "Cuivre",
		},
		"taupe": {
			"en": "Taupe",
			"fr": "Taupe",
		},
		"natural": {
			"en": "Natural",
			"fr": "Naturel",
		},
		"black frame": {
			"en": "Black Frame",
			"fr": "Cadre noir",
		},
		"white frame": {
			"en": "White Frame",
			"fr": "Cadre blanc",
		},
		"slate": {
			"en": "Slate",
			"fr": "Ardoise",
		},
		"function": {
			"en": "Function",
			"fr": "Fonction",
		},
		"reclining": {
			"en": "Reclining",
			"fr": "Inclinable",
		},
		"non-reclining": {
			"en": "Non-reclining",
			"fr": "Non inclinable",
		},
		"power reclining": {
			"en": "Power Reclining",
			"fr": "Inclinable \u00E9lectrique",
		},
		"manual reclining": {
			"en": "Manual Reclining",
			"fr": "Inclinaison manuelle",
		},
		"storage": {
			"en": "Storage",
			"fr": "Rangement",
		},
		"swivel": {
			"en": "Swivel",
			"fr": "Pivotant",
		},
		"fireplace": {
			"en": "Fireplace",
			"fr": "Foyer",
		},
		"lift-top": {
			"en": "Lift-Top",
			"fr": "Dessus relevable",
		},
		"gliding chair": {
			"en": "Gliding Chair",
			"fr": "Fauteuil coulissant",
		},
		"console": {
			"en": "Console",
			"fr": "Console",
		},
		"rocking chair": {
			"en": "Rocking Chair",
			"fr": "Fauteuil ber\u00E7ant",
		},
		"massaging": {
			"en": "Massaging",
			"fr": "Massant",
		},
		"usb port": {
			"en": "USB Port",
			"fr": "Port USB",
		},
		"futon": {
			"en": "Futon",
			"fr": "Futon",
		},
		"power lift": {
			"en": "Power Lift",
			"fr": "Soul\u00E8vement m\u00E9chanique",
		},
		"casters": {
			"en": "Casters",
			"fr": "Roulettes",
		},
		"seating": {
			"en": "Seating",
			"fr": "Si\u00E8ge",
		},
		"power headrest": {
			"en": "Power Headrest",
			"fr": "Appuie-t\u00EAte \u00E9lectrique",
		},
		"sofabed": {
			"en": "Sofabed",
			"fr": "Sofa-lit",
		},
		"tilt": {
			"en": "Tilt",
			"fr": "Inclinable",
		},
		"full-motion": {
			"en": "Full-Motion",
			"fr": "Enti\u00E8rement articul\u00E9",
		},
		"low-profile": {
			"en": "Low-Profile",
			"fr": "Profil bas",
		},
		"modular": {
			"en": "Modular",
			"fr": "Modulaire",
		},
		"nesting": {
			"en": "Nesting",
			"fr": "Gigogne",
		},
		"canopy": {
			"en": "Canopy",
			"fr": "Toit",
		},
		"nesting": {
			"en": "Nesting",
			"fr": "Gigogne",
		},
		"verde fabric panel": {
			"en": "Verde Fabric Panel",
			"fr": "Panneau Verde en tissu",
		},
		"banner": {
			"en": "Banner",
			"fr": "Bannière",
		},
		"photo frame": { 
			"en":"Photo Frame", 
			"fr":"Cadre photo" 
		},
		"verde frame": {
			"en": "Verde Frame",
			"fr": "Cadre Verde",
		},		

		"number of seats": {
			"en": "Number of seats",
			"fr": "Nombre de si\u00E8ges",
		},
		"2 seats": {
			"en": "2 Seats",
			"fr": "2 si\u00E8ges",
		},
		"4 seats": {
			"en": "4 Seats",
			"fr": "4 si\u00E8ges",
		},
		"6 seats": {
			"en": "6 Seats",
			"fr": "6 si\u00E8ges",
		},
		"height": {
			"en": "Height (Inches)",
			"fr": "Hauteur (pouces)",
		},
		"width": {
			"en": "Width (Inches)",
			"fr": "Largeur (pouces)",
		},
		"depth": {
			"en": "Depth (Inches)",
			"fr": "Profondeur (pouces)",
		},
		"over 600": {
			"en": "Over 600",
			"fr": "Au-dessus de 600",
		},

		"rug size": {
			"en": "Rug Size",
			"fr": "Taille de la carpette",
		},
		"rug height (inches)": {
			"en": "Pile Height",
			"fr": "Hauteur du poil",
		},
		"under 0.5": {
			"en": 'Flat: 0.1" to 0.5"',
			"fr": "Plat : 0,1 po \u00e0 0,5 po",
		},
		"0.5 - 0.75": {
			"en": 'Medium: 0.5" to 0.75"',
			"fr": "Moyen : 0,5 po \u00e0 0,75 po",
		},
		"0.75 & up": {
			"en": 'Shag: 0.75"+',
			"fr": "Long : 0,75 po et plus",
		},

		// DIMENSIONS
		'under 24': {
			"en": 'Under 24',
			"fr": "Moins de 24",
		},
		'under 28': {
			"en": 'Under 28',
			"fr": "Moins de 28",
		},
		'over 36': {
			"en": 'Over 36',
			"fr": "Au-dessus de 36",
		},

		// UPHOLSTERY
		"upholstery": {
			"en": "Upholstery",
			"fr": "Rev\u00EAtement",
		},
		"bonded leather": {
			"en": "Bonded Leather",
			"fr": "Cuir contrecoll\u00E9",
		},
		"chenille": {
			"en": "Chenille",
			"fr": "Chenille",
		},
		"cotton": {
			"en": "Cotton",
			"fr": "Coton",
		},
		"faux leather": {
			"en": "Faux Leather",
			"fr": "Similicuir",
		},
		"faux suede": {
			"en": "Faux Suede",
			"fr": "Su\u00E9dine",
		},
		"genuine leather": {
			"en": "Genuine Leather",
			"fr": "Cuir v\u00E9ritable",
		},
		"leather-look fabric": {
			"en": "Leather-Look Fabric",
			"fr": "Tissu d'apparence cuir",
		},
		"linen": {
			"en": "Linen",
			"fr": "Lin",
		},
		"linen-look fabric": {
			"en": "Linen-Look Fabric",
			"fr": "Tissu d'apparence lin",
		},
		"microfibre/microsuede": {
			"en": "Microfibre/Microsuede",
			"fr": "Microfibre ou microsu\u00E8de",
		},
		"polyester": {
			"en": "Polyester",
			"fr": "Polyester",
		},
		"polypropylene": {
			"en": "Polypropylene",
			"fr": "Polypropyl\u00E8ne",
		},
		"velvet": {
			"en": "Velvet",
			"fr": "Velours",
		},
		"100% recycled material": {
			"en": "100% Recycled Material",
			"fr": "Mat\u00E9riau 100 % recycl\u00E9",
		},
		"100% viscose": {
			"en": "100% Viscose",
			"fr": "100 % viscose",
		},
		"polyvinyl chloride (pvc)": {
			"en": "Polyvinyl Chloride (PVC)",
			"fr": "Chlorure de polyvinyle (PVC)",
		},
		"resin rattan": {
			"en": "Resin Rattan",
			"fr": "Rotin en r\u00E9sine",
		},
		"resin": {
			"en": "Resin",
			"fr": "R\u00E9sine",
		},
		"canvas": {
			"en": "Canvas",
			"fr": "Toile",
		},
		"olefin": {
			"en": "Olefin",
			"fr": "Oléfine",
		},

		// MATTRESS
		"mattress": {
			"en": "Mattress",
			"fr": "Matelas",
		},
		"mattress size": {
			"en": "Mattress Size",
			"fr": "Format du matelas",
		},
		"queen": {
			"en": "Queen",
			"fr": "Grand lit",
		},
		"king": {
			"en": "King",
			"fr": "Tr\u00E8s grand lit",
		},
		"full": {
			"en": "Full",
			"fr": "Lit double",
		},
		"twin": {
			"en": "Twin",
			"fr": "Lit simple",
		},
		"twin xl": {
			"en": "Twin XL",
			"fr": "Extra-longue lit simple",
		},
		"queen bed": {
			"en": "Queen Bed",
			"fr": "Grand lit",
		},
		"king bed": {
			"en": "King Bed",
			"fr": "Tr\u00E8s grand lit",
		},
		"full bed": {
			"en": "Full Bed",
			"fr": "Lit double",
		},
		"twin bed": {
			"en": "Twin Bed",
			"fr": "Lit simple",
		},
		"twin xl bed": {
			"en": "Twin XL Bed",
			"fr": "Extra-longue lit simple",
		},
		"firmness": {
			"en": "Firmness",
			"fr": "Niveau de confort ou fermet\u00E9",
		},
		"firm": {
			"en": "Firm",
			"fr": "Ferme",
		},
		"plush": {
			"en": "Plush",
			"fr": "Moelleux",
		},
		"luxury firm": {
			"en": "Luxury Firm",
			"fr": "Luxueux ferme",
		},
		"luxury plush": {
			"en": "Luxury Plush",
			"fr": "Luxueux moelleux",
		},
		"cushion firm": {
			"en": "Cushion Firm",
			"fr": "Extra-ferme",
		},
		"boxspring type": {
			"en": "Boxspring type",
			"fr": "Type de sommier",
		},
		"standard": {
			"en": "Standard",
			"fr": "Standard",
		},
		"split": {
			"en": "Split",
			"fr": "Divis\u00E9",
		},
		"adjustable": {
			"en": "Adjustable",
			"fr": "Ajustable",
		},
		"split low-profile": {
			"en": "Split Low-Profile",
			"fr": "Divis\u00E9 \u00E0 profil bas",
		},
		"mattress top": {
			"en": "Mattress Top",
			"fr": "Plateau du matelas",
		},
		"euro top": {
			"en": "Euro Top",
			"fr": "Euro-plateau",
		},
		"tight top": {
			"en": "Tight Top",
			"fr": "Dessus ferme",
		},
		"pillow-top": {
			"en": "Pillow-Top",
			"fr": "Plateau-coussin",
		},
		"euro pillow-top": {
			"en": "Euro Pillow-Top",
			"fr": "Euro-plateau \u00E9pais",
		},
		"mattress type": {
			"en": "Mattress Type",
			"fr": "Type de matelas",
		},
		"pocket coil": {
			"en": "Pocket Coil",
			"fr": "\u00C0 ressorts ensach\u00E9s",
		},
		"specialty foam": {
			"en": "Specialty Foam",
			"fr": "Avec mousse sp\u00E9cialis\u00E9s",
		},
		"innerspring": {
			"en": "Innerspring",
			"fr": "Matelas \u00E0 ressorts",
		},
		"hybrid": {
			"en": "Hybrid",
			"fr": "Hybrid",
		},
		"foam": {
			"en": "Foam",
			"fr": "Foam",
		},
		"breathable": {
			"en": "Breathable",
			"fr": "Perméable à l'air"
		},
		"temperature regulating": {
			"en": "Temperature Regulating",
			"fr": "Régulation de la température"
		},
		"moisture wicking": {
			"en": "Moisture Wicking",
			"fr": "Évacuation de l'humidité"
		},
		"wrinkle resistant": {
			"en": "Wrinkle Resistant",
			"fr": "Résistant aux plis"
		},

		// BEDROOM
		"bed size": {
			"en": "Bed Size",
			"fr": "Format du lit",
		},
		"bed features": {
			"en": "Bed Features",
			"fr": "Caract\u00E9ristiques du lit",
		},
		"platform": {
			"en": "Platform",
			"fr": "Plateforme",
		},
		"platform base": {
			"en": "Platform Base",
			"fr": "Plateformes",
		},
		"pier": {
			"en": "Pier",
			"fr": "\u00C0 Section",
		},
		"bookcase": {
			"en": "Bookcase",
			"fr": "Biblioth\u00E8que",
		},
		"crib and toddler": {
			"en": "Crib and Toddler",
			"fr": "Lit de b\u00E9b\u00E9 et bambin",
		},
		"convertible": {
			"en": "Convertible",
			"fr": "Convertible",
		},
		"panel": {
			"en": "Panel",
			"fr": "\u00C0 panneaux",
		},
		"sleigh": {
			"en": "Sleigh",
			"fr": "Lit-bateau",
		},
		"trundle": {
			"en": "Trundle",
			"fr": "Lit gigogne",
		},
		"cabinet bed": {
			"en":"Cabinet Bed",
			"fr":"Armoire-lit"
		},
		"murphy bed": {
			"en":"Murphy Bed",
			"fr":"Lit escamotable"
		},

		// DINING
		"table shape": {
			"en": "Table Shape",
			"fr": "Forme de la table",
		},
		"rectangle": {
			"en": "Rectangle",
			"fr": "Rectangulaire",
		},
		"round": {
			"en": "Round",
			"fr": "Rond",
		},
		"square": {
			"en": "Square",
			"fr": "Carr\u00E9",
		},
		"oval": {
			"en": "Oval",
			"fr": "Ovale",
		},
		"rectangular butterfly": {
			"en": "Rectangular Butterfly",
			"fr": "Papillon rectangulaire",
		},
		"corner": {
			"en": "Corner",
			"fr": "Coin",
		},
		"dining height": {
			"en": "Dining Height",
			"fr": "Hauteurs de table",
		},
		"counter": {
			"en": "Counter",
			"fr": "Comptoir",
		},
		"bar": {
			"en": "Bar",
			"fr": "Bar",
		},

		// ELECTRONICS
		"display type": {
			"en": "Display Type",
			"fr": "Type d'\u00E9cran",
		},
		"led": {
			"en": "LED",
			"fr": "DEL",
		},
		"qled": {
			"en": "QLED",
			"fr": "QLED",
		},
		"oled": {
			"en": "OLED",
			"fr": "OLED",
		},
		"lcd": {
			"en": "LCD",
			"fr": "ACL",
		},
		"qned mini led": {
			"en": "QNED Mini LED",
			"fr": "QNED Mini FRL",
		},
		"resolution": {
			"en": "Resolution",
			"fr": "R\u00E9solution",
		},
		"4k ultra hd": {
			"en": "UHD 4K",
			"fr": "UHD 4K",
		},
		"8k ultra hd": {
			"en": "UHD 8K",
			"fr": "UHD 8K",
		},
		"full hd": {
			"en": "Full HD",
			"fr": "Full HD",
		},
		"hd": {
			"en": "HD",
			"fr": "HD",
		},
		"4k ultra hd (3840)": {
			"en": "UHD 4K (3840)",
			"fr": "UHD 4K (3840)",
		},
		"8k ultra hd (7680)": {
			"en": "UHD 8K (7680)",
			"fr": "UHD 8K (7680)",
		},
		"full hd (1080)": {
			"en": "Full HD (1080)",
			"fr": "Full HD (1080)",
		},
		"hd (720)": {
			"en": "HD (720)",
			"fr": "HD (720)",
		},
		"screen size": {
			"en": "Screen Size",
			"fr": "Taille de l'\u00E9cran",
		},
		"50 and over": {
			"en": "50 and over",
			"fr": "50 et plus",
		},
		"tv features": {
			"en": "TV Features",
			"fr": "Caract\u00E9ristiques technologiques",
		},
		"smart tv": {
			"en": "Smart TV",
			"fr": "T\u00E9l\u00E9viseurs intelligents",
		},
		"wifi enabled": {
			"en": "WiFi Enabled",
			"fr": "Compatibilit\u00E9 Wi-Fi",
		},
		"curved": {
			"en": "Curved",
			"fr": "\u00C0 \u00E9cran incurv\u00E9",
		},
		"3d": {
			"en": "3D",
			"fr": "3D",
		},
		"electronics_features": {
			"en": "Electronics Features",
			"fr": "Caract\u00E9ristiques des appareils \u00E9lectroniques",
		},
		"ips panel": {
			"en": "IPS Panel",
			"fr": "\u00C9cran IPS",
		},
		"compatible with amazon alexa": {
			"en": "Compatible with Amazon Alexa",
			"fr": "Compatible avec Alexa d'Amazon",
		},
		"amazon alexa built-in": {
			"en": "Amazon Alexa Built-in",
			"fr": "Alexa d'Amazon int\u00E9gr\u00E9",
		},
		"compatible with google assistant": {
			"en": "Compatible with Google Assistant",
			"fr": "Compatible avec Google Assistant",
		},
		"google assistant built-in": {
			"en": "Google Assistant Built-in",
			"fr": "Google Assistant int\u00E9gr\u00E9",
		},
		"voice assistant": {
			"en": "Voice Assistant",
			"fr": "Assistant vocal",
		},
		"multiroom capable": {
			"en": "Multiroom Capable",
			"fr": "Capacit\u00E9 multiroom",
		},
		"surround sound": {
			"en": "Surround Sound",
			"fr": "Son ambiophonique",
		},
		"short-throw projector": {
			"en": "Short-Throw Projector",
			"fr": "Projecteur \u00E0 plage focale courte",
		},
		"gaming optimized": {
			"en": "Gaming Optimized",
			"fr": "Optimis\u00E9 pour le jeu",
		},
		"full array": {
			"en": "Full Array",
			"fr": "Matrice compl\u00E8te",
		},
		"ambient mode": {
			"en": "Ambient Mode",
			"fr": "Mode ambiant",
		},
		"art mode": {
			"en": "Art Mode",
			"fr": "Mode Art",
		},
		"lifestyle tv": {
			"en": "Lifestyle TV",
			"fr": "T\u00E9l\u00E9viseur style de vie",
		},
		"quantum dot": {
			"en": "Quantum Dot",
			"fr": "Bo\u00EEtes quantiques",
		},
		"serif": {
			"en": "Serif",
			"fr": "Serif",
		},
		"wisa compatible": {
			"en": "WiSA Compatible",
			"fr": "Compatible avec WiSA",
		},
		"atmos": {
			"en": "ATMOS",
			"fr": "ATMOS",
		},
		"smart": {
			"en": "Smart",
			"fr": "Intelligent",
		},
		"mf_sf_tags_tv_size_supported_in_": {
			"en": "TV Size Supported (in)",
			"fr": "Format du t\u00E9l\u00E9viseur support\u00E9 (po)",
		},

		// APPLIANCE
		"freezer type": {
			"en": "Freezer Type",
			"fr": "Types de cong\u00E9lateurs",
		},
		"upright": {
			"en": "Upright",
			"fr": "Vertical",
		},
		"chest": {
			"en": "Chest",
			"fr": "Horizontal",
		},
		"fuel type": {
			"en": "Fuel Type",
			"fr": "Type d'alimentation",
		},
		"electric": {
			"en": "Electric",
			"fr": "\u00C9lectrique",
		},
		"gas": {
			"en": "Gas",
			"fr": "Gaz",
		},
		"dual fuel": {
			"en": "Dual Fuel",
			"fr": "Combustible double",
		},
		"propane": {
			"en": "Propane",
			"fr": "Propane",
		},
		"natural gas": {
			"en": "Natural Gas",
			"fr": "Gaz naturel",
		},
		"microwave type": {
			"en": "Microwave Type",
			"fr": "Types de fours \u00E0 micro-ondes",
		},
		"over-the-range": {
			"en": "Over-the-Range",
			"fr": "Avec hotte int\u00E9gr\u00E9e",
		},
		"countertop": {
			"en": "Countertop",
			"fr": "Sur le comptoir",
		},
		"built-in": {
			"en": "Built-In",
			"fr": "Encastr\u00E9",
		},
		"wall oven combination": {
			"en": "Wall Oven Combination",
			"fr": "Four mural combin\u00E9 \u00E0 un four \u00E0 micro-ondes",
		},
		"total refrigerator capacity (cu. ft.)": {
			"en": "Total Refrigerator Capacity (cu. ft.)",
			"fr": "Capacit\u00E9 totale du r\u00E9frig\u00E9rateur (pi³)",
		},
		"range type": {
			"en": "Range Type",
			"fr": "Types de cuisini\u00E8res",
		},
		"freestanding": {
			"en": "Freestanding",
			"fr": "Autonome",
		},
		"slide-in": {
			"en": "Slide-In",
			"fr": "Encastrable",
		},
		"refrigerator type": {
			"en": "Refrigerator Type",
			"fr": "Types de r\u00E9frig\u00E9rateurs",
		},
		"french door": {
			"en": "French-Door",
			"fr": "Portes françaises",
		},
		"french-door": {
			"en": "French-Door",
			"fr": "Portes françaises",
		},
		"no freezer": {
			"en": "No Freezer",
			"fr": "Sans cong\u00E9lateur",
		},
		"bottom-freezer": {
			"en": "Bottom-Freezer",
			"fr": "Cong\u00E9lateur en bas",
		},
		"top-freezer": {
			"en": "Top-Freezer",
			"fr": "Cong\u00E9lateur en haut",
		},
		"specialty": {
			"en": "Specialty",
			"fr": "Sp\u00E9cial",
		},
		"side-by-side": {
			"en": "Side-by-Side",
			"fr": "C\u00F4te \u00E0 C\u00F4te",
		},
		"compact": {
			"en": "Compact",
			"fr": "Compact",
		},
		"no-freezer": {
			"en": "No-Freezer",
			"fr": "Sans Cong\u00E9lateur",
		},
		"wine cooler": {
			"en": "Wine Cooler",
			"fr": "Refroidisseur \u00E0 vin",
		},
		"wine refrigerator": {
			"en": "Wine Refrigerator",
			"fr": "Réfrigérateur à vin",
		},
		"propane refrigerator": {
			"en": "Propane Refrigerator",
			"fr": "Réfrigérateur gaz propane",
		},
		"propane freezer": {
			"en": "Propane Freezer",
			"fr": "Congélateur au propane",
		},
		"propane range": {
			"en": "Propane Range",
			"fr": "Cuisinière gaz propane",
		},
		"washer type": {
			"en": "Washer Type",
			"fr": "Types de laveuses",
		},
		"front-load": {
			"en": "Front-Load",
			"fr": "Chargement frontal",
		},
		"top-load": {
			"en": "Top-Load",
			"fr": "Chargement par le haut",
		},
		"fridge width": {
			"en": "Refrigerator Width",
			"fr": "Largeur du r\u00E9frig\u00E9rateur",
		},

		"range width": {
			"en": "Range Width",
			"fr": "Largeur de la cuisini\u00E8re",
		},
		"dishwasher width": {
			"en": "Dishwasher Width",
			"fr": "Largeur du lave-vaisselle",
		},
		"hood fan width": {
			"en": "Hood Fan Width",
			"fr": "Largeur de la hotte de cuisini\u00E8re",
		},
		"cooktop width": {
			"en": "Cooktop Width",
			"fr": "Largeur de la surface de cuisson",
		},
		"wall oven width": {
			"en": "Wall Oven Width",
			"fr": "Largeur du four mural",
		},
		"cfm": {
			"en": "CFM",
			"fr": "pi³/min",
		},
		"blower required": {
			"en": "Blower Required",
			"fr": "Ventilateur requis",
		},
		"under 200": {
			"en": "Under 200",
			"fr": "Moins de 200",
		},
		"cubic feet": {
			"en": "Cubic Feet",
			"fr": "pi³",
		},
		"appliance package": {
			"en":"Appliance Package",
			"fr":"Ensemble d’électroménagers"
		},
		"appliance packages": {
			"en":"Appliance Packages",
			"fr":"Ensembles d’électroménagers"
		},		
		"appliance features": {
			"en": "Appliance Features",
			"fr": "Caract\u00E9ristiques de l'\u00E9lectrom\u00E9nager",
		},
		"child lock": {
			"en": "Child Lock",
			"fr": "Verrouillage \u00E0 l'\u00E9preuve des enfants",
		},
		"counter-depth": {
			"en": "Counter-Depth",
			"fr": "Profondeur comptoir",
		},
		"door-in-door": {
			"en": "Door-in-Door",
			"fr": "Porte dans la porte",
		},
		"exterior water/ice dispenser": {
			"en": "Exterior Water/Ice Dispenser",
			"fr": "Distributeur externe d'eau et de gla\u00E7ons",
		},
		"fingerprint resistant": {
			"en": "Fingerprint Resistant",
			"fr": "R\u00E9sistant aux traces de doigts",
		},
		"interior water dispenser": {
			"en": "Interior Water Dispenser",
			"fr": "Distributeur d'eau interne",
		},
		"smart capable": {
			"en": "Smart Capable",
			"fr": "Compatibilit\u00E9 intelligente",
		},
		"top control:": {
			"en": "Top Control",
			"fr": "Commandes sur le dessus",
		},
		"front control:": {
			"en": "Front Control",
			"fr": "Commandes \u00E0 l'avant",
		},
		"front-control freestanding": {
			"en": "Front-Control Freestanding",
			"fr": "Amovible avec commandes \u00E0 l'avant",
		},
		"exterior ice/water dispenser": {
			"en": "Exterior Ice/Water Dispenser",
			"fr": "Distributeurs de gla\u00E7ons et d'eau \u00E0 l'ext\u00E9rieur",
		},
		"built-in thermometer": {
			"en": "Built-In Thermometer",
			"fr": "Thermomètre int\u00E9gr\u00E9",
		},
		"coil top": {
			"en": "Coil Top",
			"fr": "Dessus en serpentin",
		},
		"induction": {
			"en": "Induction",
			"fr": "Induction",
		},
		"sabbath mode": {
			"en": "Sabbath Mode",
			"fr": "Mode sabbat",
		},
		"self-clean": {
			"en": "Self-Clean",
			"fr": "Autonettoyage",
		},
		"smooth top": {
			"en": "Smooth Top",
			"fr": "Surface lisse",
		},
		"storage drawer": {
			"en": "Storage Drawer",
			"fr": "Tiroir de rangement",
		},
		"warming drawer": {
			"en": "Warming Drawer",
			"fr": "Tiroir-r\u00E9chaud",
		},
		"baking drawer": {
			"en": "Baking Drawer",
			"fr": "Tiroir de cuisson",
		},
		"convection": {
			"en": "Convection",
			"fr": "Convection",
		},
		"double oven": {
			"en": "Double Oven",
			"fr": "Four double",
		},
		"front control": {
			"en": "Front Control",
			"fr": "Commandes \u00E0 l'avant",
		},
		"air fry": {
			"en": "Air Fry",
			"fr": "Friture \u00E0 air chaud",
		},
		"high-efficiency": {
			"en": "High-Efficiency",
			"fr": "Haute efficacit\u00E9",
		},
		"steam": {
			"en": "Steam",
			"fr": "Vapeur",
		},
		"steam clean": {
			"en": "Steam Clean",
			"fr": "Nettoyage \u00E0 la vapeur",
		},
		"top control": {
			"en": "Top Control",
			"fr": "Commandes sur le dessus",
		},
		"hard food disposer": {
			"en": "Hard Food Disposer",
			"fr": "Broyeur d'aliments solides",
		},
		"reversible door": {
			"en": "Reversible Door",
			"fr": "Porte reversible",
		},
		"third rack": {
			"en": "Third Rack",
			"fr": "3e panier",
		},
		"downdraft": {
			"en": "Downdraft",
			"fr": "\u00C0 aspiration descendante",
		},
		"frost-free": {
			"en": "Frost-Free",
			"fr": "Sans givre",
		},
		"remote included": {
			"en": "Remote Included",
			"fr": "T\u00E9l\u00E9commande incluse",
		},
		"oscillating": {
			"en": "Oscillating",
			"fr": "Fonction d'oscillation",
		},
		"walkie talkie": {
			"en": "Walkie Talkie",
			"fr": "Émetteurs-récepteurs portatifs"
		},
		"smartwatch": {
			"en": "Smartwatch",
			"fr": "Montre intelligente"
		},
		"headphones": {
			"en": "Headphones",
			"fr": "Casque d'écoute"
		},
		"video game controller": {
			"en": "Video Game Controller",
			"fr": "Manette de jeu"
		},
		"gaming accessory": {
			"en": "Gaming Accessory",
			"fr": "Accessoires pour jeux"
		},
		"sleep therapy machine": {
			"en": "Sleep Therapy Machine",
			"fr": "Machines sonore pour le sommeil"
		},
		"small electronic": {
			"en": "Small Electronic",
			"fr": "Petits appareils électroniques"
		},
		"light string": {
			"en": "Light String",
			"fr": "Guirlande lumineuse"
		},
		"power bar": {
			"en": "Power Bar",
			"fr": "Multiprise"
		},
		"security camera": {
			"en": "Security Camera",
			"fr": "Caméra de sécurité"
		},
		"dashcam": {
			"en": "Dashcam",
			"fr": "Caméra de tableau"
		},
		"gaming headset": {
			"en": "Gaming headset",
			"fr": "Casque d'écoute de jeu"
		},
		"mouse": {
			"en": "Mouse",
			"fr": "Souris"
		},
		"tablet": {
			"en": "Tablet",
			"fr": "Tablette"
		},

		// DECOR
		"lamp type": {
			"en": "Lamp Type",
			"fr": "Type de lampe",
		},
		"table": {
			"en": "Table",
			"fr": "De table",
		},
		"floor": {
			"en": "Floor",
			"fr": "\u00C0 pied",
		},
		"ceiling": {
			"en": "Ceiling",
			"fr": "De plafond",
		},
		"desk": {
			"en": "Desk",
			"fr": "Bureaux",
		},

		// EXTRAS
		"feature": {
			"en": "Feature",
			"fr": "Vedette"
		},
		"black friday price": {
			"en": "Black Friday Price",
			"fr": "Prix du vendredi fou"
		},
		"boxing day price": {
			"en": "Boxing Day Price",
			"fr": "Prix du Lendemain de Noël"
		},
		"kids bedding": {
			"en": "Kids Bedding",
			"fr": "Literie pour enfants"
		},

		// CATEGORY FACETS
		"category": {
			"en": "Category",
			"fr": "Cat\u00E9gories",
		},
		"furniture": {
			"en": "Furniture",
			"fr": "Meubles"
		},
		"electronics": {
			"en": "Electronics",
			"fr": "Appareils Électroniques"
		},
		"appliances": {
			"en": "Appliances",
			"fr": "Électroménagers"
		},
		"home decor": {
			"en": "Home Decor",
			"fr": "Décoration Intérieure"
		},
		"mattresses": {
			"en": "Mattresses",
			"fr": "Matelas"
		},
		"seasonal": {
			"en": "Seasonal",
			"fr": "Saisonnier"
		},
		"outdoor living": {
			"en": "Outdoor Living",
			"fr": "Vie extérieure"
		},

		//UPHOLSTERY
		"sectional": {
			"en": "Sectional",
			"fr": "Sofas sectionnels",
		},
		"sectional sofa": {
			"en": "Sectional Sofa",
			"fr": "Sofas sectionnels",
		},
		"chair": {
			"en": "Chair",
			"fr": "Fauteuils",
		},
		"sofa": {
			"en": "Sofa",
			"fr": "Sofa",
		},
		"loveseat": {
			"en": "Loveseat",
			"fr": "Causeuses",
		},
		"ottoman": {
			"en": "Ottoman",
			"fr": "Poufs",
		},
		"ottoman with storage": { 
			"en":"Ottoman with Storage", 
			"fr":"Pouf de rangement" 
		},
		"accent chair": {
			"en": "Accent Chair",
			"fr": "Fauteuils d'appoint",
		},
		"sofa bed": {
			"en": "Sofa bed",
			"fr": "Sofa-lits",
		},

		//OCCASIONAL TABLES
		"end table": {
			"en": "End Table",
			"fr": "Tables de bout",
		},
		"coffee table": {
			"en": "Coffee Table",
			"fr": "Tables \u00E0 caf\u00E9",
		},
		"sofa table": {
			"en": "Sofa Table",
			"fr": "Tables de salon",
		},
		"occasional table package": {
			"en": "Occasional Table Package",
			"fr": "Ensembles de tables",
		},
		"console table": {
			"en": "Console Table",
			"fr": "Console",
		},
		"hall table": {
			"en": "Hall Table",
			"fr": "Table d'entr\u00E9e",
		},
		"bar cart": {
			"en": "Bar Cart",
			"fr": "Chariot-bar",
		},
		"table base": {
			"en": "Table Base",
			"fr": "Tables de salon",
		},

		//ENTERTAINMENT FURNITURE
		"tv stand": {
			"en": "TV Stand",
			"fr": "Meubles pour t\u00E9l\u00E9s",
		},
		"wall unit": {
			"en": "Wall Unit",
			"fr": "Unit\u00E9s murales",
		},
		"tv stand with fireplace": {
			"en": "TV Stand with Fireplace",
			"fr": "Meubles pour t\u00E9l\u00E9s avec foyers",
		},

		//OFFICE STORAGE
		"storage pier": {
			"en": "Storage Pier",
			"fr": "\u00C9tag\u00E8res et unit\u00E9s multim\u00E9dia",
		},
		"bureaux": {
			"en": "Bureaux",
			"fr": "Chaises de bureau",
		},
		"filing cabinet": {
			"en": "Filing Cabinet",
			"fr": "Classeurs",
		},
		"desk package": {
			"en": "Desk Package",
			"fr": "Ensembles de bureau \u00E0 domicile",
		},

			//MATTRESSES
		"queen mattress set": {
			"en": "Queen Mattress Set",
			"fr": "Ensembles matelas grand",
		},
		"king mattress set": {
			"en": "King Mattress Set",
			"fr": "Ensembles matelas tr\u00E8s grand",
		},
		"full mattress set": {
			"en": "Full Mattress Set",
			"fr": "Ensembles matelas double",
		},
		"twin mattress set": {
			"en": "Twin Mattress Set",
			"fr": "Ensembles matelas simple",
		},
		"twin xl mattress set": {
			"en": "Twin XL Mattress Set",
			"fr": "Ensembles extra-longue matelas simple",
		},
		"queen mattress": {
			"en": "Queen Mattress",
			"fr": "Matelas grand",
		},
		"king mattress": {
			"en": "King Mattress",
			"fr": "Matelas tr\u00E8s grand",
		},
		"full mattress": {
			"en": "Full Mattress",
			"fr": "Matelas double",
		},
		"twin xl mattress": {
			"en": "Twin Xl Mattress",
			"fr": "Extra-longue matelas simple",
		},
		"twin mattress": {
			"en": "Twin Mattress",
			"fr": "Matelas simple",
		},
		"duvet insert": {
			"en":"Duvet Insert",
			"fr":"Couette"
		},
		"duvet cover": {
			"en":"Duvet Cover",
			"fr":"Housse de couette"
		},
		"duvet cover set": {
			"en": "Duvet Cover Set",
			"fr": "Ensemble housse de couette",
		},
		"duvet set": {
			"en": "Duvet Set",
			"fr": "Ensemble de couette",
		},
		"mattress topper": {
			"en":"Mattress Topper",
			"fr":"Surmatelas"
		},
		"mattress protector": {
			"en": "Mattress Protector",
			"fr": "Prot\u00E8ge-matelas",
		},
		"boxspring": {
			"en": "Boxspring",
			"fr": "Sommiers",
		},
		"throw blanket": {
			"en": "Throw Blanket",
			"fr": "Jet\u00E9",
		},
		"sheet set": {
			"en": "Sheet Set",
			"fr": "Ensemble de draps",
		},
		"adjustable base": {
			"en": "Adjustable Base",
			"fr": "Base ajustable",
		},
		"bed frame": {
			"en": "Bed Frame",
			"fr": "Cadres de lit",
		},
		"comforter insert": {
			"en": "Comforter Insert",
			"fr": "Couette",
		},
		"pillow protector": {
			"en": "Pillow Protector",
			"fr": "Housse d'oreiller",
		},
		"pillow insert": {
			"en": "Pillow Insert",
			"fr": "Oreiller de rembourrage",
		},
		"pillowcase": {
			"en": "Pillowcase",
			"fr": "Taie d’oreiller",
		},

		//BEDROOM
		"bedroom package": {
			"en": "Bedroom Package",
			"fr": "Ensembles de chambre \u00E0 coucher",
		},
		"bed": {
			"en": "Bed",
			"fr": "Lit",
		},
		"headboard": {
			"en": "Headboard",
			"fr": "T\u00EAtes de lit",
		},
		"armoire": {
			"en": "Armoire",
			"fr": "Armoires",
		},
		"mirror": {
			"en": "Mirror",
			"fr": "Miroir",
		},
		"dresser": {
			"en": "Dresser",
			"fr": "Commode",
		},
		"nightstand": {
			"en": "Nightstand",
			"fr": "Table de nuit",
		},
		"crib": {
			"en": "Crib",
			"fr": "Lit de b\u00E9b\u00E9",
		},
		"bed rails": {
			"en": "Bed Rails",
			"fr": "Traverses de lit",
		},
		"changing table topper": {
			"en": "Changing Table Topper",
			"fr": "Plateau \u00C0 langer",
		},
		"changing table": {
			"en": "Changing Table",
			"fr": "Table \u00C0 langer",
		},
		"crib bedding": {
			"en": "Crib Bedding",
			"fr": "Literie pour lit de b\u00E9b\u00E9",
		},
		"crib mattress": {
			"en": "Crib Mattress",
			"fr": "Matelas pour lit de b\u00E9b\u00E9",
		},
		"daybed": {
			"en": "Daybed",
			"fr": "Lit de repos",
		},

		//DINING
		"dining room set": {
			"en": "Dining Room Set",
			"fr": "Ensembles de salle \u00E0 manger",
		},
		"dining chair": {
			"en": "Dining Chair",
			"fr": "Chaise de salle \u00E0 manger",
		},
		"bar stool": {
			"en": "Bar Stool",
			"fr": "Tabourets",
		},
		"dining table": {
			"en": "Dining Table",
			"fr": "Tables de salle \u00E0 manger",
		},
		"dining bench": {
			"en": "Dining Bench",
			"fr": "Bancs de salle \u00E0 manger",
		},
		"server": {
			"en": "Server",
			"fr": "Dessertes",
		},
		"buffet and hutch": {
			"en": "Buffet and Hutch",
			"fr": "Buffets et armoires",
		},
		"curio cabinet": {
			"en": "Curio Cabinet",
			"fr": "Armoires vitr\u00E9es",
		},
		"accent dining chair": {
			"en": "Accent Dining Chair",
			"fr": "Chaise d'appoint",
		},
		"hutch": {
			"en": "Hutch",
			"fr": "Armoires",
		},

		//ELECTRONICS
		"tv mount": {
			"en": "TV Mount",
			"fr": "Supports de t\u00E9l\u00E9",
		},
		"television": {
			"en": "Television",
			"fr": "T\u00E9l\u00E9viseurs",
		},
		"soundbar": {
			"en": "Soundbar",
			"fr": "Barres de son",
		},
		"speaker": {
			"en": "Speaker",
			"fr": "Haut-parleurs",
		},
		"bluetooth speaker": {
			"en": "Bluetooth Speaker",
			"fr": "Haut-parleur avec Bluetooth",
		},
		"receiver": {
			"en": "Receiver",
			"fr": "R\u00E9cepteurs",
		},
		"subwoofer": {
			"en": "Subwoofer",
			"fr": "Caissons de basse",
		},
		"music player": {
			"en": "Music Player",
			"fr": "Lecteur de musique",
		},
		"home theatre package": {
			"en": "Home Theatre Package",
			"fr": "Syst\u00E8me de cin\u00E9ma maison",
		},
		"streaming box": {
			"en": "Streaming Box",
			"fr": "Passerelle multim\u00E9dia de lecture en continu",
		},
		"appareil photo": {
			"en": "Appareil photo",
			"fr": "Appareil photo",
		},
		"trousse d'entretien": {
			"en": "Trousse d'entretien",
			"fr": "Trousse d'entretien",
		},
		"hdmi cable package": {
			"en": "HDMI Cable Package",
			"fr": "Trousse de c\u00E2bles HDMI",
		},
		"hdmi cable": {
			"en": "HDMI Cable",
			"fr": "C\u00E2ble HDMI",
		},
		"cable management": {
			"en": "Cable Management",
			"fr": "Syst\u00E8me de gestion des c\u00E2bles",
		},
		"sound bar mount": {
			"en": "Sound Bar Mount",
			"fr": "Syst\u00E8me de fixation pour barre de son",
		},
		"printer": {
			"en": "Printer",
			"fr": "Imprimante",
		},
		"projector": {
			"en": "Projector",
			"fr": "Projecteur",
		},

		//APPLIANCES - LAUNDRY
		"dryer": {
			"en": "Dryer",
			"fr": "S\u00E9cheuses",
		},
		"washer": {
			"en": "Washer",
			"fr": "Laveuses",
		},
		"laundry set": {
			"en": "Laundry Set",
			"fr": "Ensemble pour la buanderie",
		},
		"laundry pedestal": {
			"en": "Laundry Pedestal",
			"fr": "Pi\u00E9destaux",
		},
		"laundry set with pedestal washer": {
			"en": "Laundry Set With Pedestal Washer",
			"fr": "Ensemble laveuse et sécheuse avec laveuse-pi\u00E9destal",
		},
		"laundry all-in-one": {
			"en": "Laundry All-in-One",
			"fr": "Buanderie tout-en-un",
		},
		"stacking kit": {
			"en": "Stacking Kit",
			"fr": "Ensemble de superposition",
		},
		"dryer vent": {
			"en": "Dryer Vent",
			"fr": "\u00C9vent pour s\u00E9cheuse",
		},
		"stacked laundry set": {
			"en": "Stacked Laundry Set",
			"fr": "Laveuse et s\u00E9cheuse empil\u00E9es",
		},
		"laundry centre": {
			"en": "Laundry Centre",
			"fr": "Centre de lavage",
		},
		"washer hose": {
			"en": "Washer Hose",
			"fr": "Tuyaux pour laveuse",
		},
		"washer and dryer in one": {
			"en": "Washer and Dryer in One",
			"fr": "Appareil 2 en 1 laveuse et s\u00E9cheuse",
		},
		"dryer hose": {
			"en": "Dryer Hose",
			"fr": "Tuyaux pour s\u00E9cheuse",
		},
		"blender": {
			"en": "Blender",
			"fr": "M\u00E9langeur",
		},
		"mixer": {
			"en": "Mixer",
			"fr": "Batteur",
		},
		"coffee maker": {
			"en": "Coffee Maker",
			"fr": "Cafeti\u00E8re",
		},
		"deep fryer": {
			"en": "Deep Fryer",
			"fr": "Friteuse",
		},
		"grill": {
			"en": "Grill",
			"fr": "Gril",
		},
		"slow cooker": {
			"en": "Slow Cooker",
			"fr": "Mijoteuse",
		},
		"food processor": {
			"en": "Food Processor",
			"fr": "Robot culinaire",
		},
		"kettle": {
			"en": "Kettle",
			"fr": "Bouilloire",
		},
		"convection toaster oven": {
			"en": "Convection Toaster Oven",
			"fr": "Grille-pain four \u00E0 convection",
		},
		"rice cooker": {
			"en": "Rice Cooker",
			"fr": "Cuiseur \u00E0 riz",
		},
		"toaster": {
			"en": "Toaster",
			"fr": "Grille-pain",
		},
		"pressure cooker": {
			"en": "Pressure Cooker",
			"fr": "Autocuiseur \u00E9lectrique",
		},
		"food dehydrator": {
			"en": "Food Dehydrator",
			"fr": "D\u00E9shydrateur de nourriture",
		},

		"cooler": {
			"en": "Cooler",
			"fr": "Glaci\u00E8re",
		},
		"hydroponic grower": {
			"en": "Hydroponic Grower",
			"fr": "Syst\u00E8me de culture hydroponique",
		},
		"herb grower": {
			"en": "Herb Grower",
			"fr": "Cultivateur \u00E0 herbes",
		},
		"seed kit": {
			"en": "Seed Kit",
			"fr": "Trousse de capsules de graines",
		},
		"mosquito repellent": {
			"en": "Mosquito Repellent",
			"fr": "Bouclier anti-moustiques",
		},

		//APPLIANCES - KITCHEN
		"refrigerator": {
			"en": "Refrigerator",
			"fr": "R\u00E9frig\u00E9rateurs",
		},
		"range hood": {
			"en": "Range Hood",
			"fr": "Hottes de cuisine",
		},
		"range hood part": {
			"en": "Range Hood Part",
			"fr": "Pi\u00E8ce de hotte de cuisini\u00E8re",
		},
		"range top": {
			"en": "Range Top",
			"fr": "Dessus de cuisini\u00E8re",
		},
		"dishwasher": {
			"en": "Dishwasher",
			"fr": "Lave-vaisselles",
		},
		"electric range": {
			"en": "Electric Range",
			"fr": "Cuisini\u00E8re \u00E9lectrique",
		},
		"gas range": {
			"en": "Gas Range",
			"fr": "Cuisini\u00E8re \u00E0 gaz",
		},
		"induction range": { 
			"en":"Induction Range", 
			"fr":"Cuisinière à induction" 
		},
		"electric cooktop": {
			"en": "Electric Cooktop",
			"fr": "Surface de cuisson \u00E9lectrique",
		},
		"electric wall oven": {
			"en": "Electric Wall Oven",
			"fr": "Four mural \u00E9lectrique",
		},
		"over-the-range microwave": {
			"en": "Over-the-Range Microwave",
			"fr": "Four \u00E0 micro-ondes \u00E0 hotte int\u00E9gr\u00E9e",
		},
		"gas cooktop": {
			"en": "Gas Cooktop",
			"fr": "Surface de cuisson \u00E0 gaz",
		},
		"range hood ducting": {
			"en": "Range Hood Ducting",
			"fr": "Conduit pour hotte de cuisini\u00E8re",
		},
		"countertop microwave": {
			"en": "Countertop Microwave",
			"fr": "Four \u00E0 micro-ondes de comptoir",
		},
		"beverage centre": {
			"en": "Beverage Centre",
			"fr": "Refroidisseur \u00E0 boissons",
		},
		"double wall oven": {
			"en": "Double Wall Oven",
			"fr": "Four mural double",
		},
		"filter": {
			"en": "Filter",
			"fr": "Filtre",
		},
		"trim kit": {
			"en": "Trim Kit",
			"fr": "Trousse d'encastrement",
		},
		"built-in microwave": {
			"en": "Built-In Microwave",
			"fr": "Four \u00E0 micro-ondes encastr\u00E9",
		},
		"dual fuel range": {
			"en": "Dual Fuel Range",
			"fr": "Cuisini\u00E8re hybride",
		},
		"electric warming drawer": {
			"en": "Electric Warming Drawer",
			"fr": "Tiroir-r\u00E9chaud \u00E9lectrique",
		},
		"cong\u00E9lateurs": {
			"en": "Cong\u00E9lateurs",
			"fr": "Cong\u00E9lateurs",
		},
		"refrigerator and freezer set": {
			"en": "Refrigerator And Freezer Set",
			"fr": "Ensemble r\u00E9frig\u00E9rateur et cong\u00E9lateur",
		},
		"food disposer": {
			"en": "Food Disposer",
			"fr": "Broyeur \u00E0 d\u00E9chets",
		},
		"snow cone maker": {
			"en": "Snow Cone Maker",
			"fr": "Machine à cônes à neige",
		},
		"fondue fountain": {
			"en": "Fondue Fountain",
			"fr": "Fontaine de chocolat à fondue",
		},
		"egg cooker": {
			"en": "Egg Cooker",
			"fr": "Cuiseur à oeufs",
		},
		"planter": {
			"en": "Planter",
			"fr": "Pot à fleurs",
		},
		"tabletop decor": {
			"en": "Tabletop Decor",
			"fr": "Décoration de table",
		},
		"bowl": {
			"en": "Bowl",
			"fr": "Bol",
		},
		"outdoor decor": {
			"en": "Outdoor Decor",
			"fr": "Décoration pour l'extérieur",
		},
		"bookends": {
			"en": "Bookends",
			"fr": "Appui-livres",
		},
		"candle holder": {
			"en": "Candle Holder",
			"fr": "Bougeoir",
		},
		"pen holder": {
			"en": "Pen Holder",
			"fr": "Porte-crayons",
		},

		//APPLIANCES - FEATURES
		/*"built-in sink": {
			"en": "Built-In Sink",
			"fr": "Lavabo int\u00E9gr\u00E9",
		},*/
		"built-in sink": {
			"en": "Built-In Pretreat Station",
			"fr": "Station de pr\u00E9traitement int\u00E9gr\u00E9",
		},
		"built-in pretreat station": {
			"en": "Built-In Pretreat Station",
			"fr": "Station de pr\u00E9traitement int\u00E9gr\u00E9",
		},
		"cold wash": {
			"en": "Cold Wash",
			"fr": "Lavage \u00E0 l'eau froide",
		},
		"drum light": {
			"en": "Drum Light",
			"fr": "Lumi\u00E8re du tambour",
		},
		"hoses included": {
			"en": "Hoses Included",
			"fr": "Tuyaux inclus",
		},
		"pedestal compatible": {
			"en": "Pedestal Compatible",
			"fr": "Compatible avec pi\u00E9destal",
		},
		"sensor dry": {
			"en": "Sensor Dry",
			"fr": "S\u00E9chage par capteur",
		},
		"stackable": {
			"en": "Stackable",
			"fr": "Superposable",
		},
		"large capacity": {
			"en": "Large Capacity",
			"fr": "Grande capacit\u00E9",
		},
		"extra-large capacity": {
			"en": "Extra-Large Capacity",
			"fr": "Tr\u00E8s grande capacit\u00E9",
		},
		"sanitize": {
			"en": "Sanitize",
			"fr": "D\u00E9sinfection",
		},

		//APPLIANCES - OTHER
		"noise level (db)": {
			"en": "Noise Level (Decibels)",
			"fr": "Niveau sonore (d\u00E9cibels)",
		},
		"accessory kit": {
			"en": "Accessory Kit",
			"fr": "Trousse d'accessoires",
		},
		"extension kit": {
			"en": "Extension Kit",
			"fr": "Trousse de rallonge",
		},
		"hose": {
			"en": "Hose",
			"fr": "Tuyaux",
		},
		"rack": {
			"en": "Rack",
			"fr": "Grille de four",
		},
		"ice maker": {
			"en": "Ice Maker",
			"fr": "Machine \u00E0 gla\u00E7ons",
		},
		"waste compactor": {
			"en": "Waste Compactor",
			"fr": "Compacteur de d\u00E9chets",
		},
		"built-in coffee maker": {
			"en": "Built-In coffee Maker",
			"fr": "Machine \u00E0 caf\u00E9 int\u00E9gr\u00E9e",
		},
		"clothes steamer": {
			"en": "Clothes Steamer",
			"fr": "D\u00E9froisseur de v\u00EAtements \u00E0 la vapeur",
		},
		"fan": {
			"en": "Fan",
			"fr": "Ventilateur",
		},
		"vacuum": {
			"en": "Vacuum",
			"fr": "Aspirateurs",
		},
		"central vacuum": {
			"en": "Central Vacuum",
			"fr": "Aspirateur central",
		},
		"air conditioner": {
			"en": "Air Conditioner",
			"fr": "Cong\u00E9lateurs",
		},
		"barbecue": {
			"en": "Barbecue",
			"fr": "Barbecue",
		},
		"barbecue cover": {
			"en": "Barbecue Cover",
			"fr": "Housse de barbecue",
		},
		"natural gas conversion kit": {
			"en": "Natural gas conversion kit",
			"fr": "Ensemble de conversion au gaz naturel",
		},
		"hardware": {
			"en": "Hardware",
			"fr": "Quincaillerie",
		},
		"backsplash": {
			"en":"Backsplash",
			"fr":"Dosseret"
		},
		"backsplash kit": {
			"en": "Backsplash Kit",
			"fr": "Trousse de dosseret",
		},
		"air fryer": {
			"en": "Air Fryer",
			"fr": "Friteuse \u00E0 air",
		},

		//ACCENT FURNITURE
		"accent cabinet": {
			"en": "Accent Cabinet",
			"fr": "Armoire d\u00E9corative",
		},
		"electric fireplace": {
			"en": "Electric Fireplace",
			"fr": "Foyers \u00E9lectriques",
		},
		"bench": {
			"en": "Bench",
			"fr": "Banc",
		},
		"coat rack": {
			"en": "Coat Rack",
			"fr": "Portemanteaux",
		},
		"cabinet with fireplace": {
			"en": "Cabinet with Fireplace",
			"fr": "Commode avec foyer",
		},
		"mirror cabinet": {
			"en": "Mirror Cabinet",
			"fr": "Miroir avec armoire",
		},

		//HOME DECOR
		"indoor area rug": {
			"en": "Indoor Area Rug",
			"fr": "Carpette pour l'int\u00E9rieur",
		},
		"wall art": {
			"en": "Wall Art",
			"fr": "Art",
		},
		"lamp": {
			"en": "Lamp",
			"fr": "Lampes",
		},
		"indoor throw pillow": {
			"en": "Indoor Throw Pillow",
			"fr": "Coussin d\u00E9coratif pour l'int\u00E9rieur",
		},
		"lamp package": {
			"en": "Lamp Package",
			"fr": "Ensemble lampes",
		},
		"flameless candles": {
			"en": "Flameless Candles",
			"fr": "Chandelles sans flamme",
		},
		"sham": {
			"en": "Sham",
			"fr": "Couvre-oreillers",
		},
		"smart mirror": {
			"en": "Smart Mirror",
			"fr": "Miroir intelligent",
		},
		"vanity set": {
			"en": "Vanity Set",
			"fr": "Ensemble coiffeuse",
		},
		"ceiling light": {
			"en": "Ceiling Light",
			"fr": "Luminaire suspendu",
		},

		// OUTDOOR
		"patio sectional": {
			"en": "Patio Sectional",
			"fr": "Sofa sectionnel pour la terrasse",
		},
		"patio seat": {
			"en": "Patio Seat",
			"fr": "Si\u00E8ge pour la terrasse",
		},
		"patio seating": {
			"en": "Patio Seating",
			"fr": "Salle de s\u00E9jour pour la terrasse",
		},
		"conversation set": {
			"en": "Conversation Set",
			"fr": "Ensemble de conversation",
		},
		"parasol pour la terrasse": {
			"en": "Parasol pour la terrasse",
			"fr": "Parasol pour la terrasse",
		},
		"patio seating package": {
			"en": "Patio Seating Package",
			"fr": "Ensemble de salle de s\u00E9jour pour la terrasse",
		},
		"patio chaise lounger": {
			"en": "Patio Chaise Lounger",
			"fr": "Chaise longue pour la terrasse",
		},
		"patio dining package": {
			"en": "Patio Dining Package",
			"fr": "Ensemble de salle \u00E0 manger pour la terrasse",
		},
		"patio ottoman": {
			"en": "Patio Ottoman",
			"fr": "Pouf pour la terrasse",
		},
		"fire table": {
			"en": "Fire Table",
			"fr": "Foyer-tables",
		},
		"outdoor accent pillow": {
			"en": "Outdoor Accent Pillow",
			"fr": "Coussins ext\u00E9rieurs",
		},
		"outdoor area rug": {
			"en": "Outdoor Area Rug",
			"fr": "Carpette pour l'ext\u00E9rieur",
		},
		"outdoor throw pillow": {
			"en": "Outdoor Throw Pillow",
			"fr": "Coussin d\u00E9coratif pour l'ext\u00E9rieur",
		},
		"patio dining table": {
			"en": "Patio Dining Table",
			"fr": "Table de coin-repas pour la terrasse",
		},
		"patio umbrella": {
			"en": "Patio Umbrella",
			"fr": "Parasol pour la terrasse",
		},
		"patio umbrella base": {
			"en": "Patio Umbrella Base",
			"fr": "Socle de parasol pour la terrasse",
		},
		"patio umbrella package": {
			"en": "Patio Umbrella Package",
			"fr": "Ensemble parasol pour la terrasse",
		},
		"patio dining chair": {
			"en": "Patio Dining Chair",
			"fr": "Chaise pour la terrasse",
		},
		"patio occasional table": {
			"en": "Patio Occasional Table",
			"fr": "Table d'appoint pour la terrasse",
		},
		"patio tile": {
			"en": "Patio Tile",
			"fr": "Carreaux pour la terrasse",
		},
		"patio cover": {
			"en": "Patio Cover",
			"fr": "Housse de meubles pour la terrasse",
		},

		//MISC
		"wi-fi camera": {
			"en": "Wi-Fi Camera",
			"fr": "Cam\u00E9ra Wi-Fi",
		},
		"smart plug": {
			"en": "Smart Plug",
			"fr": "Prise intelligente",
		},
		"under cabinet": {
			"en": "Under Cabinet",
			"fr": "Sous l'armoire"
		},
		"chimney": {
			"en": "Chimney",
			"fr": "Cheminée"
		},
		"built in": {
			"en": "Built In",
			"fr": "Encastrée"
		},
		"island": {
			"en": "Island",
			"fr": "Îlot"
		},
		"outdoor": {
			"en": "Outdoor",
			"fr": "Extérieure"
		},
		"knife set": {
			"en": "Knife Set",
			"fr": "Ensemble de couteaux"
		},
		"mixer attachment": {
			"en": "Mixer Attachment",
			"fr": "Accessoire pour batteur"
		},
		"detergent": {
			"en": "Detergent",
			"fr": "Détergent"
		},
		"griddle": {
			"en": "Griddle",
			"fr": "Plaque chauffante"
		},
		"cookware set": {
			"en": "Cookware Set",
			"fr": "Batterie de cuisine"
		},
		"dishwasher part": {
			"en": "Dishwasher Part",
			"fr": "Pièce de lave-vaisselle"
		},
		"vacuum sealer": {
			"en": "Vacuum Sealer",
			"fr": "Scelleuse sous vide"
		},
		"vacuum sealer bags": {
			"en": "Vacuum Sealer Bags",
			"fr": "Sacs pour scelleuse sous vide"
		},
		"air purifier": {
			"en": "Air Purifier",
			"fr": "Purificateur d'air"
		},
		"media shelf": {
			"en": "Media Shelf",
			"fr": "Tablette multimédia"
		},
		"media stand": {
			"en": "Media Stand",
			"fr": "Support multimédia"
		},
		"office chair": {
			"en": "Office Chair",
			"fr": "Chaise de bureau"
		},
		"hall stand": {
			"en": "Hall Stand",
			"fr": "Portemanteau"
		},
		"indoor/outdoor area rug": {
			"en": "Indoor/Outdoor Area Rug",
			"fr": "Carpette pour l'intérieur et l'extérieur"
		},
		"machine washable area rug": {
			"en": "Machine Washable Area Rug",
			"fr": "Carpette lavable à la machine"
		},
		"accent living room decor": {
			"en": "Accent Living Room Decor",
			"fr": "Décoration pour salle de séjour"
		},
		"comforter set": {
			"en": "Comforter Set",
			"fr": "Ensemble d'édredon"
		},
		"artificial plant": {
			"en": "Artificial Plant",
			"fr": "Plante artificielle"
		},
		"curtain": {
			"en": "Curtain",
			"fr": "Rideau"
		},
		"jersey": {
			"en": "Jersey",
			"fr": "Maillot"
		},
		"key holder": {
			"en": "Key Holder",
			"fr": "Porte-clés"
		},
		"lunch box": {
			"en": "Lunch Box",
			"fr": "Boîte à lunch"
		},
		"post fitter": {
			"en": "Post Fitter",
			"fr": "Fixation de base"
		},
		"lighting adapter": {
			"en": "Lighting Adapter",
			"fr": "Adaptateur d’éclairage"
		},
		"planter": {
			"en": "Planter",
			"fr": "Pot à fleurs"
		},
		"portable uv": {
			"en": "Portable UV",
			"fr": "Lumière UV portative"
		},
		"bean bag": {
			"en": "Bean Bag",
			"fr": "Fauteuil poire"
		},
		"cushion tray": {
			"en": "Cushion Tray",
			"fr": "Plateau coussin"
		},
		"dog bed": {
			"en": "Dog Bed",
			"fr": "Lit de chien"
		},
		"commercial grade": {
			"en": "Commercial Grade",
			"fr": "Qualité commerciale"
		},
		"storage cabinet": {
			"en": "Storage Cabinet",
			"fr": "Armoire de arrangement"
		},
		"pencil drawer": {
			"en": "Pencil Drawer",
			"fr": "Tiroir à crayons"
		},

		"watch functions": {
			"en": "Watch Functions",
			"fr": "Fonctions de la montre"
		},
		"running": {
			"en": "Running",
			"fr": "Course"
		},
		"outdoor": {
			"en": "Outdoor",
			"fr": "Extérieur"
		},
		"hiking": {
			"en": "Hiking",
			"fr": "Randonnée"
		},
		"gps": {
			"en": "GPS",
			"fr": "GPS"
		},
		"fashion": {
			"en": "Fashion",
			"fr": "Mode"
		},
		"tactical": {
			"en": "Tactical",
			"fr": "Tactique"
		},
		"activity tracking": {
			"en": "Activity Tracking",
			"fr": "Suivi d'activités"
		},
		"golf": {
			"en": "Golf",
			"fr": "Golf"
		},
		"fitness": {
			"en": "Fitness",
			"fr": "Entraînement"
		},
		"sport": {
			"en": "Sport",
			"fr": "Sport"
		},
		"swimming": {
			"en": "Swimming",
			"fr": "Natation"
		},
		"shop for": {
			"en": "Shop For",
			"fr": "Magasinez pour"
		},
		"men": {
			"en": "Men",
			"fr": "Hommes"
		},
		"women": {
			"en": "Women",
			"fr": "Femmes"
		},
		"kids": {
			"en": "Kids",
			"fr": "Enfants"
		},
		"over ear": {
			"en": "Over Ear",
			"fr": "Supra-auriculaire"
		},
		"gaming": {
			"en": "Gaming",
			"fr": "Jeu"
		},
		"wireless": {
			"en": "Wireless",
			"fr": "Sans fil"
		},
		"noise cancelling": {
			"en": "Noise Cancelling",
			"fr": "Suppression du bruit"
		},
		"headset": {
			"en": "Headset",
			"fr": "Casque d'écoute"
		},
		"bluetooth": {
			"en": "Bluetooth",
			"fr": "Bluetooth"
		},
		"earbud": {
			"en": "Earbud",
			"fr": "Écouteurs"
		},

		"game tables": {
			"en": "Game Tables",
			"fr": "Tables de jeux"
		},
		"air hockey": {
			"en": "Air Hockey",
			"fr": "Hockey pneumatique"
		},
		"billiards": {
			"en": "Billiards",
			"fr": "Billard"
		},
		"foosball": {
			"en": "Foosball",
			"fr": "Table de soccer"
		},
		"shuffleboard": {
			"en": "Shuffleboard",
			"fr": "Jeu de galets"
		},
		"darts": {
			"en": "Darts",
			"fr": "Fléchettes"
		},
		"table tennis": {
			"en": "Table Tennis",
			"fr": "Tennis de table"
		},
		"pickleball": {
			"en": "Pickleball",
			"fr": "Tennis léger"
		},
		"dice": {
			"en": "Dice",
			"fr": "Dés"
		},
		"bocce": {
			"en": "Bocce",
			"fr": "Pétanques"
		},
		"bottle battle": {
			"en": "Bottle Battle",
			"fr": "Jeu de bataille de bouteilles"
		},
		"wooden blocks": {
			"en": "Wooden Blocks",
			"fr": "Blocs en bois"
		},
		"cornhole": {
			"en": "Cornhole",
			"fr": "Jeu de poches"
		},
		"horseshoes": {
			"en": "Horseshoes",
			"fr": "Fers à cheval"
		},
		"washer toss": {
			"en": "Washer Toss",
			"fr": "Lancer de rondelles"
		},
		"quoit": {
			"en": "Quoit",
			"fr": "Palet"
		},
		"ring toss": {
			"en": "Ring Toss",
			"fr": "Lancer d’anneaux"
		},
		"airpod case": {
			"en": "AirPod Case",
			"fr": "Étui pour écouteurs AirPods"
		},
		"compact pliers": {
			"en": "Compact Pliers",
			"fr": "Pinces compactes"
		},
		"compact phone stylus": {
			"en": "Compact Phone Stylus",
			"fr": "Stylet compact pour téléphone"
		},
		"compact scissors": {
			"en": "Compact Scissors",
			"fr": "Ciseaux compacts"
		},
		"wallet": {
			"en": "Wallet",
			"fr": "Portefeuille"
		},
		"bottle opener": {
			"en": "Bottle Opener",
			"fr": "Décapsuleur"
		},
		"anti-fog glasses solution": {
			"en": "Anti-Fog Glasses Solution",
			"fr": "Vaporisateur anti-buée pour lunettes"
		},
		"id tag": {
			"en": "ID Tag",
			"fr": "Étiquette d'identification"
		},
		"money clip": {
			"en": "Money Clip",
			"fr": "Pince à billets"
		},
		"humidifier": { 
			"en":"Humidifier", 
			"fr":"Humidificateur" 
		},
		"massager": { 
			"en":"Massager", 
			"fr":"Appareil de massage" 
		},
		"heating pad": { 
			"en":"Heating Pad", 
			"fr":"Coussin chauffant" 
		},
		"foot warmer": { 
			"en":"Foot Warmer", 
			"fr":"Appareil chauffant pour les pieds" 
		},"appliance package": {
				"en": "Appliance Package",
				"fr": "Ensemble D’électroménagers"
				},"beach towel": {
				"en": "Beach Towel",
				"fr": "Serviette de plage"
				},},
  };
  algolia.translation_helpers = {
    no_result_for: function(text, render) {
		return algolia.translations.core.noResult[algoliaLang] + render(text);
    },
    try_clear_or_change_input: function(text, render) {
		var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
		var html_tags = text.match(regex);
		if (algoliaLang == 'en') {
			var noResultSolution = 'Try ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]);
		} else {
			var noResultSolution = 'Essayez ' + render(html_tags[0]) + ' de réinitialiser les filtres ' + render(html_tags[1]) + ' ou ' + render(html_tags[2]) + ' de modifier votre saisie ' + render(html_tags[3]);
		};
		return (noResultSolution);
    },

    outOf: function() {
		return (
			this.page * this.hitsPerPage +
			1 +
			'-' +
			Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
			' ' + algolia.translations.core.outOf[algoliaLang]
		);
    },

    translation: function(text, render) {
		return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
